module.exports = __webpack_public_path__ + "img/logo.83f20307.png";